import { useTranslation } from 'react-i18next';
import React, { FunctionComponent, useEffect, useState } from "react";

import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import { Button, Checkbox, Form, Radio, Select, Typography } from "antd";
import { DetailContent } from "../detail-content/DetailContent";
import CustomCard from "../../../../../components/custom-card/CustomCard";
import "./DetailInfoTab.scss";
import { useNavigate } from "react-router-dom";
import { routesConfig } from "../../../../../config/routes";
type DetailInfoTabProps = {
  detailData: any;
  memberList: any;
};
const DetailInfoTab: FunctionComponent<DetailInfoTabProps> = ({
  detailData,
  memberList,
}) => {
  const { t } = useTranslation();
  const [listHtmlData, setListHtmlData] = useState<any[]>();
  const navigate = useNavigate();

  useEffect(() => {
    const htmlData = memberList.map((item: any, index: any) => (
      <div
        className="course-plan-managment-detail-info-appraisal"
        style={{ marginBottom: 20, padding: 10, backgroundColor: "#FAFAFA" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ fontSize: "15px", fontWeight: 5 }}>{t("Thành viên", "Thành viên")}</div>
          <div>
            <Button
              style={{ width: 80, height: 25 }}
              onClick={() => {
                navigate(
                  `/${routesConfig.coursePlan}/${routesConfig.organizeAppraisalBoard}/${routesConfig.detailInfoMemberAppraisalBoard}/${item.user_id}`,
                  {
                    state: detailData,
                  }
                );
              }}
            >
              {t("Xem chi tiết", "Xem chi tiết")}
            </Button>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
          }}
        >
          <Form.Item style={{ width: "40%" }}>
            <Select
              showSearch
              optionFilterProp="children"
              defaultValue={item.name}
              options={memberList.map(
                (member: { user_id: any; name: any }) => ({
                  value: member.user_id,
                  label: member.name,
                })
              )}
              placeholder={t("Chọn thành viên", "Chọn thành viên")}
              disabled
            />
          </Form.Item>
          <div style={{ marginLeft: 30 }}>
            <Form.Item label="">
              <Checkbox.Group
                defaultValue={[item.isLeader]}
                disabled
                style={{ width: "100%" }}
              >
                <Checkbox value={1}>{t("Chủ tịch HĐ", "Chủ tịch HĐ")}</Checkbox>
                <Checkbox value={0} style={{ marginLeft: 10 }}>
                  {t("Thành viên", "Thành viên")}
                </Checkbox>
              </Checkbox.Group>
            </Form.Item>
          </div>
        </div>
      </div>
    ));
    setListHtmlData(htmlData);
  });
  return (
    <DetailContent>
      <CustomCard
        className="card-info--wrapper"
        title={
          <div className="card-heading--info">
            <Typography.Title level={5}>
              {detailData.organizationCode} - {detailData.organizationName}
            </Typography.Title>
            <Typography.Text
              className="sub-title"
              style={{ width: "90%", wordWrap: "break-word" }}
            >
              {detailData.organizationRemark}
            </Typography.Text>
          </div>
        }
      ></CustomCard>

      <CustomCard
        className="card-info--wrapper"
        title={
          <div className="card-heading--info">
            <Typography.Title level={4} style={{ fontSize: "17px" }}>
              {t("Thành viên hội đồng thẩm định", "Thành viên hội đồng thẩm định")}
            </Typography.Title>
          </div>
        }
      >
        <Typography.Text style={{ fontSize: "17px" }}></Typography.Text>
        {listHtmlData}
      </CustomCard>
    </DetailContent>
  );
};

export default DetailInfoTab;
